export const blankCostProfile = () => ({
  profileId: null,
  status: 'draft',
  currencyCode: '',
  billingTimezone: 'America/New_York',
  effectiveStart: '',
  effectiveEnd: '',
  analysisYears: '',
  discountRate: '',
  inflationRate: '',
  modeledGenerationCostPerKwh: '',
  modeledAnnualGenerationKwh: '',
  modeledAnnualGenerationChangeRate: '',
  notes: '',
  tariffComponents: [],
  assetCosts: [],
  outageAssumptions: [],
});

const omitEmpty = (object) => Object.fromEntries(
  Object.entries(object).filter(([, value]) => value !== '' && value !== null && value !== undefined)
);

const optionalInteger = (value) => value === '' || value == null ? undefined : Number(value);

export const costProfileToPayload = (form) => ({
  ...omitEmpty({
    effectiveStart: form.effectiveStart,
    effectiveEnd: form.effectiveEnd,
    currencyCode: form.currencyCode,
    billingTimezone: form.billingTimezone,
    analysisYears: optionalInteger(form.analysisYears),
    discountRate: form.discountRate,
    inflationRate: form.inflationRate,
    modeledGenerationCostPerKwh: form.modeledGenerationCostPerKwh,
    modeledAnnualGenerationKwh: form.modeledAnnualGenerationKwh,
    modeledAnnualGenerationChangeRate: form.modeledAnnualGenerationChangeRate,
    notes: form.notes,
  }),
  tariffComponents: form.tariffComponents.map((item, index) => {
    const rawSchedule = omitEmpty(item.schedule || {});
    const schedule = rawSchedule.billingPeriodStartDay === undefined ? rawSchedule : {
      ...rawSchedule,
      billingPeriodStartDay: Number(rawSchedule.billingPeriodStartDay),
    };
    return omitEmpty({
      componentName: item.componentName,
      componentType: item.componentType,
      rate: item.rate,
      rateUnit: item.rateUnit,
      localTimeStart: item.localTimeStart,
      localTimeEnd: item.localTimeEnd,
      appliesWeekdays: item.appliesWeekdays?.length ? item.appliesWeekdays : undefined,
      appliesMonths: item.appliesMonths?.length ? item.appliesMonths : undefined,
      schedule: Object.keys(schedule).length ? schedule : undefined,
      demandIntervalMinutes: optionalInteger(item.demandIntervalMinutes),
      calculationOrder: optionalInteger(item.calculationOrder) ?? index,
    });
  }),
  assetCosts: form.assetCosts.map((item) => {
    const recurrence = omitEmpty(item.recurrence || {});
    return omitEmpty({
      siteId: item.siteId,
      assetId: item.assetId,
      assetClass: item.assetClass,
      costCategory: item.costCategory,
      amount: item.amount,
      amountUnit: item.amountUnit,
      startYear: optionalInteger(item.startYear),
      startDate: item.startDate,
      recurrence: Object.keys(recurrence).length ? recurrence : undefined,
      escalationRate: item.escalationRate,
      included: item.included,
    });
  }),
  outageAssumptions: form.outageAssumptions.map((item) => omitEmpty({
    scenarioName: item.scenarioName,
    valueBasis: item.valueBasis,
    value: item.value,
    annualEventCount: item.annualEventCount,
    annualDurationHours: item.annualDurationHours,
    avoidedFraction: item.avoidedFraction,
    enabled: item.enabled,
    notes: item.notes,
  })),
});

export const costProfileToForm = (profile = {}) => ({
  ...blankCostProfile(),
  ...profile,
  tariffComponents: (profile.tariffComponents || []).map((item) => ({
    componentName: '', componentType: '', rate: '', rateUnit: '',
    localTimeStart: '', localTimeEnd: '', demandIntervalMinutes: '', calculationOrder: '',
    ...item,
    schedule: item.schedule || {},
    appliesWeekdays: item.appliesWeekdays || [],
    appliesMonths: item.appliesMonths || [],
  })),
  assetCosts: (profile.assetCosts || []).map((item) => ({
    assetClass: '', costCategory: '', amount: '', amountUnit: '', startYear: '',
    startDate: '', escalationRate: '', included: true,
    ...item,
    recurrence: item.recurrence || {},
  })),
  outageAssumptions: (profile.outageAssumptions || []).map((item) => ({
    scenarioName: '', valueBasis: 'per_hour', value: '', annualEventCount: '',
    annualDurationHours: '', avoidedFraction: '', enabled: false, notes: '',
    ...item,
  })),
});
